var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sections" }, [
      _c(
        "section",
        [
          _c("ContactPurchase", {
            attrs: {
              conversation: _vm.message.conversation,
              "job-profile-id": _vm.message.jobProfile.id,
              "job-id": _vm.message.job.id,
              pseudonym: _vm.message.pseudonym,
              type: "accept",
              initiator: "applicant"
            },
            on: { purchase: _vm.onContacted }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }